/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {SendEmailsResponse} from '../models/SendEmailsResponse';
import type {WelcomeEmailSendRequest} from '../models/WelcomeEmailSendRequest';

export interface GetSendWelcomeEmailsProgress$Request {
    id: string;
}

export interface GetSendWelcomeEmailsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSendWelcomeEmailsProgressRequest = createAction<PayloadData<void, GetSendWelcomeEmailsProgress$Request>>('BULK_SEND_WELCOME_EMAILS__GET_SEND_WELCOME_EMAILS_PROGRESS__REQUEST');
export const getSendWelcomeEmailsProgressSuccess = createAction<PayloadData<BulkProgress, GetSendWelcomeEmailsProgress$Request>>('BULK_SEND_WELCOME_EMAILS__GET_SEND_WELCOME_EMAILS_PROGRESS__SUCCESS');
export const getSendWelcomeEmailsProgressFailure = createAction<PayloadData<Error, GetSendWelcomeEmailsProgress$Request, true>>('BULK_SEND_WELCOME_EMAILS__GET_SEND_WELCOME_EMAILS_PROGRESS__FAILURE');

export const getSendWelcomeEmailsProgressActions = [
    getSendWelcomeEmailsProgressRequest,
    getSendWelcomeEmailsProgressSuccess,
    getSendWelcomeEmailsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSendWelcomeEmailsProgress = (meta: GetSendWelcomeEmailsProgress$Request, config?: GetSendWelcomeEmailsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getSendWelcomeEmailsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/welcome-emails/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSendingResult$Request {
    id: string;
}

export interface GetSendingResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSendingResultRequest = createAction<PayloadData<void, GetSendingResult$Request>>('BULK_SEND_WELCOME_EMAILS__GET_SENDING_RESULT__REQUEST');
export const getSendingResultSuccess = createAction<PayloadData<SendEmailsResponse, GetSendingResult$Request>>('BULK_SEND_WELCOME_EMAILS__GET_SENDING_RESULT__SUCCESS');
export const getSendingResultFailure = createAction<PayloadData<Error, GetSendingResult$Request, true>>('BULK_SEND_WELCOME_EMAILS__GET_SENDING_RESULT__FAILURE');

export const getSendingResultActions = [
    getSendingResultRequest,
    getSendingResultSuccess,
    getSendingResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSendingResult = (meta: GetSendingResult$Request, config?: GetSendingResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getSendingResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/welcome-emails`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendWelcomeEmails$Request {
    welcomeEmailSendRequest: WelcomeEmailSendRequest;
    reason?: string;
}

export interface SendWelcomeEmails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendWelcomeEmailsRequest = createAction<PayloadData<void, SendWelcomeEmails$Request>>('BULK_SEND_WELCOME_EMAILS__SEND_WELCOME_EMAILS__REQUEST');
export const sendWelcomeEmailsSuccess = createAction<PayloadData<string, SendWelcomeEmails$Request>>('BULK_SEND_WELCOME_EMAILS__SEND_WELCOME_EMAILS__SUCCESS');
export const sendWelcomeEmailsFailure = createAction<PayloadData<Error, SendWelcomeEmails$Request, true>>('BULK_SEND_WELCOME_EMAILS__SEND_WELCOME_EMAILS__FAILURE');

export const sendWelcomeEmailsActions = [
    sendWelcomeEmailsRequest,
    sendWelcomeEmailsSuccess,
    sendWelcomeEmailsFailure
] as const;

/**
 * @param {WelcomeEmailSendRequest} meta.welcomeEmailSendRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendWelcomeEmails = (meta: SendWelcomeEmails$Request, config?: SendWelcomeEmails$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: sendWelcomeEmailsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/users/welcome-emails`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.welcomeEmailSendRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkSending$Request {
    id: string;
}

export interface StopBulkSending$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkSendingRequest = createAction<PayloadData<void, StopBulkSending$Request>>('BULK_SEND_WELCOME_EMAILS__STOP_BULK_SENDING__REQUEST');
export const stopBulkSendingSuccess = createAction<PayloadData<void, StopBulkSending$Request>>('BULK_SEND_WELCOME_EMAILS__STOP_BULK_SENDING__SUCCESS');
export const stopBulkSendingFailure = createAction<PayloadData<Error, StopBulkSending$Request, true>>('BULK_SEND_WELCOME_EMAILS__STOP_BULK_SENDING__FAILURE');

export const stopBulkSendingActions = [
    stopBulkSendingRequest,
    stopBulkSendingSuccess,
    stopBulkSendingFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkSending = (meta: StopBulkSending$Request, config?: StopBulkSending$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkSendingActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/welcome-emails`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

